import { Feature } from 'core/enums/features';

export const FeatureRoutes: Partial<Record<Feature, string>> = {
  [Feature.Account]: '/account',
  [Feature.BillingExplained]: '/account/billing-explained',
  [Feature.ViewBalance]: '/account/view-balance',
  [Feature.MonthlyStatements]: '/account/monthly-statements',
  [Feature.PaymentMethods]: '/account/update-payment-method',
  [Feature.TransactionHistory]: '/account/transactions',
  [Feature.AmountToPay]: '/account/amount-to-pay',
  [Feature.Dashboard]: '/dashboard',
  [Feature.Products]: '/products',
  [Feature.Offers]: '/offers',
  [Feature.HolidayHome]: '/hardware/holiday-home',
  [Feature.AllProducts]: '/all-products',
  [Feature.Subscriptions]: '/subscriptions',
  [Feature.Action]: '/action',
  [Feature.Rewards]: '/rewards',
  [Feature.Premium]: '/premium-status',
  [Feature.Internet]: '/internet',
  [Feature.Insurance]: '/insurance',
  [Feature.RentalHistory]: '/boxoffice/rental-history',
  [Feature.BoxOffice]: '/boxoffice',
  [Feature.RewardsPremiumStatus]: '/premium-status',
  [Feature.RewardsWhatIsPremium]: '/what-is-premium',
  [Feature.FixError]: '/fix-errors',
};